import PropTypes from 'prop-types';
import React from 'react';
import { StyledImage, StyledLabel, StyledQuickFilter } from './styled-quick-filter';

const { forwardRef, useCallback } = React;

const propTypes = {
	label: PropTypes.string.isRequired,
	image: PropTypes.shape({
		dataTestId: PropTypes.string,
		isLazy: PropTypes.bool,
		imageLink: PropTypes.string.isRequired,
	}),
	link: PropTypes.string.isRequired,
	className: PropTypes.string,
	clickCallback: PropTypes.func,
	dataAnalyticsId: PropTypes.string,
	dataTestId: PropTypes.string,
};

const defaultProps = {
	className: 'fuse-quick-filter',
	clickCallback: undefined,
	dataAnalyticsId: undefined,
	dataTestId: 'fuse-quick-filter-test-id',
	image: {},
};

const QuickFilter = forwardRef(
	(
		{ label, image, link, className, clickCallback, dataAnalyticsId, dataTestId, ...others },
		ref,
	) => {
		const { dataTestId: imageDataTestId, isLazy, imageLink } = image;
		const clickHandler = useCallback(
			(e) => {
				if (typeof clickCallback === 'function') clickCallback(e, ref);
			},
			[clickCallback],
		);

		return (
			<StyledQuickFilter
				{...others}
				className={className}
				data-analyticsid={dataAnalyticsId}
				data-testid={dataTestId}
				href={link}
				onClick={clickHandler}
				ref={ref}
			>
				<StyledImage
					dataTestId={imageDataTestId}
					fallbackSource={imageLink}
					isLazy={isLazy}
					{...image}
				/>
				<StyledLabel>{label}</StyledLabel>
			</StyledQuickFilter>
		);
	},
);

QuickFilter.propTypes = propTypes;
QuickFilter.defaultProps = defaultProps;

export { QuickFilter };

export default QuickFilter;
